<template>
  <div class="fangDetail">
    <div class="main-content column-me" v-if="detailItem">
      <div class="top-div" :style="{'bottom':(detailItem.status.value===0||detailItem.status.value===7)?'0px':'60px'}">
        <div class="row-me padding20">
          <!--左侧内容-->
          <div class="left-div">
            <!--基本信息-->
            <div class="row-me row-center">
              <div class="blue-line"></div>
              <div class="black-title">基本信息</div>
            </div>
            <div class="table-border-l-t margin-top20">
              <div class="row-me">
                <div class="title">处方订单号</div>
                <div class="content">{{ detailItem.orderNo }}</div>
                <div class="title">医院名称</div>
                <div class="content">{{ detailItem.hospitalName }}</div>
                <div class="title">医院单号</div>
                <div class="content">{{ detailItem.prescriptionNumber }}</div>
              </div>
              <div class="row-me">
                <div class="title">机构名称</div>
                <div class="content">{{ detailItem.mechName }}</div>
                <div class="title">合单工单号</div>
                <div class="content">{{ detailItem.mergeOrderNo }}</div>
                <div class="title">关联库房</div>
                <div class="content">{{ detailItem.pharmacyName }}</div>
              </div>
              <div class="row-me">
                <div class="title">患者姓名</div>
                <div class="content">{{ detailItem.patientName }}</div>
                <div class="title">患者性别</div>
                <div class="content">{{ detailItem.patientSex }}</div>
                <div class="title">患者年龄</div>
                <div class="content">{{ detailItem.patientAge }}</div>
              </div>
              <div class="row-me">
                <div class="title">患者电话</div>
                <div class="content">{{ detailItem.patientMobile }}</div>
                <div class="title">开方医生</div>
                <div class="content">{{ detailItem.doctorName }}</div>
                <div class="title">所在科室</div>
                <div class="content">{{ detailItem.department }}</div>
              </div>
              <div class="row-me">
                <div class="title">煎药方案</div>
                <div class="content flex1">
                  <div class="line2" :title="detailItem.decoctSchemeContent">
                    {{ detailItem.decoctSchemeContent }}
                  </div>
                </div>
              </div>
              <div class="row-me">
                <div class="title">备注</div>
                <div class="content flex1">
                  {{ detailItem.remark ? detailItem.remark : '无' }}
                </div>
              </div>
            </div>

            <!--加工信息-->
            <div class="row-me row-center margin-top30">
              <div class="blue-line"></div>
              <div class="black-title">加工信息</div>
              <div class="flex1"></div>
              <div class="row-me row-center blue-text" @click="clickEditProcess"
                   v-if="(detailItem.status.value===1||detailItem.status.value===2)&&canOperate">
                <el-icon>
                  <edit/>
                </el-icon>
                修改信息
              </div>
            </div>
            <div class="table-border-l-t margin-top20">
              <!--中医外治-->
              <div v-if="detailItem.val==='wy'">
                <div class="row-me">
                  <div class="title">加工剂型</div>
                  <div class="content">{{ detailItem.processType }}</div>
                  <div class="title">是否代煎</div>
                  <div class="content"
                       v-if="detailItem.val === 't' || detailItem.val === 'd' || detailItem.val === 'z'">
                    {{ detailItem.isDecoction ? '代煎' : '自煎' }}
                  </div>
                  <div class="content" v-else>代煎</div>
                  <div class="title">处方类型</div>
                  <div class="content">{{ detailItem.processType }}</div>
                </div>
                <div class="row-me">
                  <div class="title">小袋数</div>
                  <div class="content">{{ detailItem.doseNums }}</div>
                  <div class="title">次数</div>
                  <div class="content flex1">{{ detailItem.frequency }}</div>
                  <div class="title">包装量</div>
                  <div class="content flex1">{{ detailItem.packageNums }}</div>
                </div>
                <div class="row-me">
                  <div class="title">服用方法</div>
                  <div class="content">{{ detailItem.takeMethod }}</div>
                  <div class="title">单剂量g</div>
                  <div class="content">{{ detailItem.doseWeight }}</div>
                  <div class="title">总剂量g</div>
                  <div class="content flex1 row-me row-center">
                    <span>{{ detailItem.totalWeight }}</span>
                    <div class="row-me row-center red-text flex1 margin-left10"
                         v-if="detailItem.weightWaring&&detailItem.weightWaring!==''">
                      <el-icon>
                        <warningfilled/>
                      </el-icon>
                      <div>重量不足</div>
                    </div>
                  </div>
                </div>
              </div>
              <!--其他剂型-->
              <div v-else>
                <div class="row-me">
                  <div class="title">加工剂型</div>
                  <div class="content">{{ detailItem.processType }}</div>
                  <div class="title">是否代煎</div>
                  <div class="content"
                       v-if="detailItem.val === 't' || detailItem.val === 'd' || detailItem.val === 'z'">
                    {{ detailItem.isDecoction ? '代煎' : '自煎' }}
                  </div>
                  <div class="content" v-else>代煎</div>
                  <div class="title">处方类型</div>
                  <div class="content">
                    {{ detailItem.type === 0 ? '中药处方' : detailItem.type === 1 ? '中医外治' : '' }}
                  </div>
                </div>
                <div class="row-me">
                  <div class="title" v-if="detailItem.val === 'w' || detailItem.val === 'g' || detailItem.val === 's'">
                    天数
                  </div>
                  <div class="title" v-else>剂数</div>
                  <div class="content"
                       v-if="detailItem.val === 't' || detailItem.val === 'd' || detailItem.val === 'z'">
                    {{ detailItem.doseNums }}剂*{{ detailItem.oneDoseNums }}袋
                  </div>
                  <div class="content"
                       v-else-if="detailItem.val === 'w' || detailItem.val === 'g' || detailItem.val === 's'">
                    {{ detailItem.takeDay }}
                  </div>
                  <div class="content" v-else>{{ detailItem.doseNums }}</div>
                  <div class="title">次数</div>
                  <div class="content flex1">{{ detailItem.frequency }}</div>
                  <div class="title">包装量</div>
                  <div class="content flex1">{{ detailItem.packageNums }}</div>
                </div>
                <div class="row-me">
                  <div class="title">服用方法</div>
                  <div class="content">{{ detailItem.takeMethod }}</div>
                  <div class="title">单剂量g</div>
                  <div class="content">{{ detailItem.doseWeight }}</div>
                  <div class="title">总剂量g</div>
                  <div class="content flex1 row-me row-center">
                    <span>{{ detailItem.totalWeight }}</span>
                    <div class="row-me row-center red-text flex1 margin-left10"
                         v-if="detailItem.weightWaring&&detailItem.weightWaring!==''">
                      <el-icon>
                        <warningfilled/>
                      </el-icon>
                      <div>重量不足</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--结算信息-->
            <div class="row-me row-center margin-top30">
              <div class="blue-line"></div>
              <div class="black-title">结算信息</div>
            </div>
            <div class="table-border-l-t margin-top20">
              <div class="row-me">
                <div class="title">成本药价</div>
                <div class="content">{{ detailItem.costPrice }}</div>
                <div class="title">零售药价</div>
                <div class="content">{{ detailItem.salePrice }}</div>
                <div class="title">加工费</div>
                <div class="content">{{ detailItem.processFee }}</div>
              </div>
              <div class="row-me">
                <div class="title">包材费</div>
                <div class="content">{{ detailItem.packageFee }}</div>
                <div class="title">代煎费</div>
                <div class="content flex1">{{ detailItem.fryingFee }}</div>
                <div class="title">运费</div>
                <div class="content flex1">
                  <div class="row-me row-center" v-if="!canOperate">
                    {{ detailItem.freightFee }}
                  </div>
                  <div v-else>
                    <div class="row-me center-all" v-if="detailItem.showEditPrice">
                      <div class="width80">
                        <el-input style="width: 100%;" v-model="detailItem.freightFee"
                                  @input="()=>{detailItem.freightFee = $method.checkInput(detailItem.freightFee,2)}">
                        </el-input>
                      </div>
                      <img src="../../assets/img/ok.png" class="img-table pointer"
                           @click="clickPriceOk(detailItem)">
                      <img src="../../assets/img/cancel.png" class="img-table pointer"
                           @click="clickPriceCancel(detailItem)">
                    </div>
                    <div class="row-me center-all pointer" v-else @click="clickShowEdit(detailItem)">
                      <div class="flex1 margin-right10">{{ detailItem.freightFee }}</div>
                      <img src="../../assets/img/edit.png" class="img-table pointer margin-right20">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row-me">
                <div class="title">销售金额</div>
                <div class="content flex1">{{ detailItem.totalPrice }}</div>
              </div>
            </div>

            <!--配送信息-->
            <div class="row-me row-center margin-top30">
              <div class="blue-line"></div>
              <div class="black-title">配送信息</div>
              <div class="flex1"></div>
              <div class="row-me row-center blue-text" @click="clickEditSend"
                   v-if="(detailItem.status.value===1||detailItem.status.value===2||detailItem.status.value===3
                   ||detailItem.status.value===6)&&canOperate">
                <el-icon>
                  <edit/>
                </el-icon>
                修改信息
              </div>
              <div class="row-me row-center blue-text" @click="clickSendInfo" v-if="detailItem.status.value===7">
                查看发货信息
              </div>
            </div>
            <div class="table-border-l-t margin-top20">
              <div class="row-me">
                <div class="title">配送状态</div>
                <div class="content">
                  {{ detailItem.status.value === 6 ? '待发货' : detailItem.status.value === 7 ? '已发货' : '待发货前' }}
                </div>
                <div class="title">配送方式</div>
                <div class="content">
                  {{ detailItem.sfDeliveryCompany ? detailItem.sfDeliveryCompany : detailItem.deliveryCompany }}
                </div>
                <div class="title">快递单号</div>
                <div class="content">{{ detailItem.deliveryNo }}</div>
              </div>
              <div class="row-me">
                <div class="title">运费方式</div>
                <div class="content" v-if="!this.$method.isEmpty(detailItem.sfDeliveryType)">
                  {{
                    detailItem.sfDeliveryType === 1 ? '到付' : detailItem.sfDeliveryType === 2 ? '月结' : detailItem.sfDeliveryType === 0 ? '寄付' : ''
                  }}
                  {{ this.$method.isEmpty(detailItem.insuranceStr) ? '' : '(' + detailItem.insuranceStr + ')' }}
                </div>
                <div class="content" v-else>
                  {{
                    detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType === 2 ? '月结' : detailItem.deliveryType === 0 ? '寄付' : ''
                  }}
                  {{ this.$method.isEmpty(detailItem.insuranceStr) ? '' : '(' + detailItem.insuranceStr + ')' }}
                </div>
                <div class="title">收货人</div>
                <div class="content">{{ detailItem.sfName ? detailItem.sfName : detailItem.receiveName }}</div>
                <div class="title">收货电话</div>
                <div class="content">{{ detailItem.sfMobile ? detailItem.sfMobile : detailItem.receiveMobile }}</div>
              </div>
              <div class="row-me">
                <div class="title">收货地址</div>
                <div class="content flex1">
                  {{ detailItem.sfProvince ? detailItem.sfProvince : detailItem.receiveProvince }}
                  {{ detailItem.sfCity ? detailItem.sfCity : detailItem.receiveCity }}
                  {{ detailItem.sfRegion ? detailItem.sfRegion : detailItem.receiveRegion }}
                  {{ detailItem.sfAddress ? detailItem.sfAddress : detailItem.receiveAddress }}
                </div>
              </div>
            </div>

            <!--流程状态-->
            <div class="row-me row-center margin-top30">
              <div class="blue-line"></div>
              <div class="black-title">流程状态</div>
            </div>
            <div class="border-grey margin-top20 time-div">
              <el-timeline>
                <el-timeline-item v-for="(activity, index) in activities" :key="index" :type="activity.type"
                                  :size="activity.size">
                  <template #dot>
                    <!-- 0 作废 1 通过 2 进行中 -1未操作 -->
                    <img src="../../assets/img/icon_cg.png" v-if="activity.status.value===1">
                    <img src="../../assets/img/icon_shibai.png" v-if="activity.status.value===0">
                    <div class="step-text1" v-if="activity.status.value===2">{{ index + 1 }}</div>
                    <div class="step-text" v-if="activity.status.value===-1">{{ index + 1 }}</div>
                  </template>
                  <div class="row-me">
                    <div class="column-me height90">
                      <!-- 	type: primary / success / warning / danger / info -->
                      <div class="title1"
                           :style="{'color':activity.status.value===-1?'#A9B6C4':'#252630'}">
                        {{ activity.title }}
                      </div>
                      <div class="title2" v-if="activity.operatorTime&&activity.operatorTime!==''">
                        {{ activity.operatorTime }}
                      </div>
                      <div class="title2" v-if="activity.operator&&activity.operator!==''">
                        接方员：{{ activity.operator }}
                      </div>
                    </div>
                    <div class="info-div margin-left50 font-size18"
                         v-if="activity.status.value===0&&index===0">
                      <span class="red-text">接方作废：</span>
                      {{ activity.content }}
                    </div>
                    <div class="info-div margin-left50 font-size18"
                         v-if="activity.status.value===0&&index===1">
                      <span class="red-text">审方作废：</span>
                      {{ activity.content }}
                    </div>
                    <div class="info-div margin-left50 font-size18"
                         v-if="activity.status.value===0&&index===2">
                      <span class="red-text">加工作废：</span>
                      {{ activity.content }}
                    </div>
                    <div class="info-div margin-left50 font-size18"
                         v-if="activity.status.value===1&&index===1&&activity.content!==null">
                      <span class="text-green">强制通过：</span>
                      {{ activity.content }}
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
          <!--右侧内容-->
          <div class="right-div">
            <!--中医外治显示处方信息-->
            <div class="margin-bottom20" v-if="detailItem.val==='wy'&&constitutes.length>0">
              <div class="row-me row-center">
                <div class="blue-line"></div>
                <div class="black-title">处方信息</div>
              </div>
              <div class="margin-top20">
                <el-table ref="drugTable" :data="constitutes" border
                          header-cell-class-name="table-header-style" cell-class-name="table-cell-style">
                  <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                  <el-table-column prop="sn" label="药品编码" align="center" width="100"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="sourceName" label="药品" align="center"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="spec" label="品质规格" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="nums" label="袋数" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="takeMethod" label="用法" align="center"
                                   show-overflow-tooltip></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="row-me row-center">
              <div class="blue-line"></div>
              <div class="black-title">处方明细</div>
              <div class="flex1"></div>
              <div class="red-text" v-if="detailItem.status.value===2">
                *有超剂量、配伍禁忌需上传开方医师签字确认后方可通过
              </div>
            </div>
            <div class="margin-top20">
              <el-table ref="drugTable" :data="drugs" border
                        header-cell-class-name="table-header-style" cell-class-name="table-cell-style">
                <el-table-column type="index" label="序号" align="center" width="80"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="sn" label="药品编码" align="center" width="100"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="药品" align="center" width="120" show-overflow-tooltip>
                  <template #default="scope">
                    <div v-if="this.$method.isEmpty(scope.row.drugName)||scope.row.drugName!==scope.row.sourceName"
                         style="color: red;">
                      {{ scope.row.sourceName }}
                    </div>
                    <div v-else>{{ scope.row.sourceName }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="spec" label="品质规格" align="center" width="100"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="本店替换药品" align="center"
                                 v-if="detailItem.status.value!==1" width="150" show-overflow-tooltip>
                  <template #default="scope">
                    <div class="row-me center-all">
                      <div class="width150"
                           v-if="this.$method.isEmpty(scope.row.drugName)&&detailItem.status.value===2">
                        <div class="flex1">
                          <el-select placeholder="请输入" style="width: 100%;" filterable
                                     clearable v-model="scope.row.drugId" @change="e=>drugChange(e,scope.row)">
                            <el-option v-for="item in drugArray" :key="item.id"
                                       :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div v-else>{{ scope.row.drugName }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="nums" label="剂量" align="center" width="80"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="processMethod" label="煎药方法" align="center" width="110" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="预审记录" align="left" show-overflow-tooltip>
                  <template #default="scope">
                    <div class="row-me row-center" v-if="scope.row.waring">
                      <el-icon color="#FF6969">
                        <warningfilled/>
                      </el-icon>
                      <div class="font-size16">
                        {{ scope.row.waring }}
                      </div>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!--工艺记录-->
        <div class="margin-left20 padding-bottom80 margin-right20">
          <div class="row-me row-center margin-bottom20">
            <div class="blue-line"></div>
            <div class="black-title">工艺记录</div>
          </div>
          <el-table :data="records" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="name" label="工艺名称" align="center" show-overflow-tooltip
                             width="100"></el-table-column>
            <el-table-column prop="duration" label="计划时长" align="center" show-overflow-tooltip
                             width="120"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" show-overflow-tooltip
                             width="100"></el-table-column>
            <el-table-column prop="equipmentName" label="设备名称" align="center"
                             show-overflow-tooltip width="150"></el-table-column>
            <el-table-column label="照片" align="center">
              <template #default="scope">
                <div class="row-me row-center">
                  <el-image :src="item" :preview-src-list="scope.row.images.split(',')" fit="scale-down"
                            class="img-photo" hide-on-click-modal v-if="scope.row.images"
                            v-for="(item,index) in scope.row.images.split(',')" :key="index">
                    <template #error>
                      <img src="../../assets/img/no_img_small.png" slot="error"
                           class="width100Per height100Per objScaleDown">
                    </template>
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip
                             width="150"></el-table-column>
            <el-table-column prop="operator" label="操作人" align="center" show-overflow-tooltip
                             width="110"></el-table-column>
            <el-table-column prop="operatorStartTime" label="操作开始时间" align="center"
                             show-overflow-tooltip width="220"></el-table-column>
            <el-table-column prop="operatorEndTime" label="操作结束时间" align="center"
                             show-overflow-tooltip width="220"></el-table-column>
            <el-table-column prop="actualDuration" label="实际时长" align="center" show-overflow-tooltip
                             width="120"></el-table-column>
          </el-table>
        </div>
      </div>


      <!--操作按钮-->
      <!--状态:0已作废,1待接方,2待审方,3待配药,4配药中,5制药中,6待发货,7已完成,8调剂作废,9调剂,10复核,11泡药,
      12煎药,13包装,14审方作废-->
      <div class="bottom-div row-me row-center flex-end1">
        <div class="btn-blank width100 btn-height40" @click="clickAddRemark"
             v-if="detailItem.status.value!==7&&canOperate">
          添加备注
        </div>
        <div class="btn-blank width120 btn-height40 margin-left10" @click="clickPrintTransfer">打印调配单</div>
        <div class="btn-blank width150 btn-height40 margin-left10" @click="clickPrintBarCode">打印调配条码</div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickPrintLabel">打印标签</div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExportMedicine">导出药品</div>
        <!--待接方-->
        <div class="row-me row-center" v-if="detailItem.status.value===1&&canOperate">
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickPass"
               v-if="this.$method.isEmpty(detailItem.jieStatus)">
            接方通过
          </div>
          <div class="btn-red width100 btn-height40 margin-left10" @click="clickDelete"
               v-if="this.$method.isEmpty(detailItem.jieStatus)">接方作废
          </div>
        </div>
        <!--待审方-->
        <div class="row-me row-center" v-if="detailItem.status.value===2&&canOperate">
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickPassCheck">审方通过</div>
          <div class="btn-red width100 btn-height40 margin-left10" @click="clickDelete">审方作废
          </div>
        </div>
        <!--调剂-->
        <div class="row-me row-center" v-if="detailItem.status.value===9&&canOperate">
          <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUploadImage('调剂')"
               v-if="detailItem.tiaoStatus===1||detailItem.tiaoStatus===2">上传照片
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickTiaoPass">调剂完成</div>
          <div class="btn-red width100 btn-height40 margin-left10" @click="clickDelete">调剂作废
          </div>
        </div>
        <!--复核-->
        <div class="row-me row-center" v-if="detailItem.status.value===10&&canOperate">
          <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUploadImage('复核')"
               v-if="detailItem.fuStatus===null">上传照片
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickFuHePass">复核通过</div>
          <div class="btn-red width100 btn-height40 margin-left10" @click="clickDelete">复核驳回
          </div>
        </div>
        <!--泡药-->
        <div class="row-me row-center" v-if="detailItem.status.value===11&&canOperate">
          <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUploadImage('泡药')"
               v-if="detailItem.paoStatus===1">上传照片
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickStartPao"
               v-if="detailItem.paoStatus===0||detailItem.paoStatus===null">开始泡药
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickEndPao"
               v-if="detailItem.paoStatus===1">泡药完成
          </div>
        </div>
        <!--煎药-->
        <div class="row-me row-center" v-if="detailItem.status.value===12&&canOperate">
          <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUploadImage('煎药')"
               v-if="detailItem.jianStatus===1">上传照片
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickStartJian"
               v-if="detailItem.jianStatus===0||detailItem.jianStatus===null">开始煎药
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickEndJian"
               v-if="detailItem.jianStatus===1">煎药完成
          </div>
        </div>
        <!--包装-->
        <div class="row-me row-center" v-if="detailItem.status.value===13&&canOperate">
          <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUploadImage('包装')"
               v-if="detailItem.baoStatus===1">上传照片
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickStartBao"
               v-if="detailItem.baoStatus===0||detailItem.baoStatus===null">开始包装
          </div>
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickEndBao"
               v-if="detailItem.baoStatus===1">包装完成
          </div>
        </div>
        <!--待发货-->
        <div class="row-me row-center" v-if="detailItem.status.value===6&&canOperate">
          <div class="btn-green width100 btn-height40 margin-left10" @click="clickSend">发货</div>
        </div>

      </div>
    </div>

    <!-- 处方作废 -->
    <el-dialog :title="deleteTitle" v-model="visibleDelete" width="40%" :destroy-on-close="true" v-if="detailItem">
      <deleteFang :ids="[detailItem.id]" :source="deleteSource" :title="deleteLeftTitle"></deleteFang>
    </el-dialog>

    <!-- 审方强制通过 -->
    <el-dialog title="强制通过" v-model="visiblePassForce" width="40%" :destroy-on-close="true" v-if="detailItem">
      <passFang :ids="[detailItem.id]" :drugs="drugs" :info="forceInfo"
                :doctorSignature="detailItem.doctorSignature"></passFang>
    </el-dialog>

    <!-- 修改加工信息 -->
    <el-dialog title="修改加工信息" v-model="visibleProcess" width="40%" :destroy-on-close="true">
      <div class="margin30">
        <div class="row-me row-center">
          <div class="width80 text-justify">服用方法</div>
          <div>：</div>
          <div class="flex1">
            <el-select v-model="selectWay" placeholder="服用方法" style="width: 100%;" filterable clearable>
              <el-option v-for="item in ['内服','外用','熏洗','清洗']" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="width80 text-justify">包装量</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入包装量" style="width: 100%;" clearable v-model="amount"></el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blue width140 btn-height40" @click="clickSaveProcess">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancelProcess">取消</div>
        </div>
      </div>
    </el-dialog>

    <!-- 修改配送信息 -->
    <el-dialog title="修改配送信息" v-model="visibleDelivery" width="40%" :destroy-on-close="true">
      <div class="margin30">
        <div class="row-me row-center">
          <div class="width80 text-justify">运费方式</div>
          <div>：</div>
          <div class="flex1">
            <el-select v-model="selectWaySend" placeholder="配送方式" style="width: 100%;" filterable clearable>
              <el-option v-for="item in [{id:0,name:'寄付'},{id:1,name:'到付'},{id:2,name:'月结'}]"
                         :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="width80 text-justify">收货人</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入收货人" style="width: 100%;" clearable v-model="person"></el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="width80 text-justify">联系电话</div>
          <div>：</div>
          <div class="flex1">
            <el-input placeholder="请输入联系电话" style="width: 100%;" clearable v-model="phone"></el-input>
          </div>
        </div>
        <div class="row-me margin-top30">
          <div class="width80 text-justify">收货地址</div>
          <div>：</div>
          <div class="flex1">
            <div class="row-me row-center">
              <div class="flex1">
                <el-select v-model="selectProvince" placeholder="省" style="width: 100%;" filterable
                           clearable @change="cityChange1">
                  <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                             :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="selectCity" placeholder="市" style="width: 100%;" filterable
                           clearable @change="cityChange2">
                  <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="selectArea" placeholder="区" style="width: 100%;" filterable
                           clearable>
                  <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入详细地址" style="width: 100%;" clearable v-model="address"
                        maxlength="50"></el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top150">
          <div class="btn-blue width140 btn-height40" @click="clickSaveSend">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancelSend">取消</div>
        </div>
      </div>
    </el-dialog>

    <!-- 添加备注 -->
    <el-dialog title="添加备注" v-model="visibleRemark" width="820px" top="20vh" :destroy-on-close="true">
      <div class="padding10-20">
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" clearable v-model="remark"
                    maxlength="500" show-word-limit rows="10"></el-input>
        </div>
        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="visibleRemark=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveRemark">保存</div>
        </div>
      </div>
    </el-dialog>

    <!-- 打印调配单 -->
    <div v-show="false" v-if="detailItem">
      <printPrescription ref="printPage" :ids="[detailItem.id]"></printPrescription>
    </div>

    <!-- 打印调配码 -->
    <el-drawer v-model="showCodeDrawer" title="打印调配条码" direction="rtl" :destroy-on-close="true"
               v-if="detailItem">
      <printTransferCode :persons="[detailItem]"></printTransferCode>
    </el-drawer>

    <!-- 打印标签 -->
    <el-drawer v-model="showLabelDrawer" title="打印标签" direction="rtl" :destroy-on-close="true" v-if="detailItem">
      <printLabel :persons="[detailItem]"></printLabel>
    </el-drawer>

    <!-- 预审提示框 -->
    <el-dialog title="预审提示" v-model="visibleCheckTips" width="40%" :destroy-on-close="true">
      <div>
        <div>检查到选中的工单号{{ checkTipsItem.orderNo }}可能存在以下问题：</div>
        <div class="grey-div margin-top20">
          <div class="margin-bottom20" v-if="!this.$method.isEmpty(checkTipsItem.kucun)">
            <div class="row-me row-center">
              <img src="../../assets/img/tanhao1.png">
              <div class="font-size22 margin-left10" style="color: #F29600;">库存不足提醒</div>
            </div>
            <div class="margin-top10">
              {{ checkTipsItem.kucun }}
            </div>
          </div>
          <div class="margin-bottom20" v-if="!this.$method.isEmpty(checkTipsItem.sbji)">
            <div class="row-me row-center">
              <img src="../../assets/img/tanhao1.png">
              <div class="font-size22 margin-left10" style="color: #F29600;">配伍禁忌提醒</div>
            </div>
            <div class="margin-top10">
              {{ checkTipsItem.sbji }}
            </div>
          </div>
          <div class="margin-bottom20" v-if="!this.$method.isEmpty(checkTipsItem.sbchao)">
            <div class="row-me row-center">
              <img src="../../assets/img/tanhao1.png">
              <div class="font-size22 margin-left10" style="color: #F29600;">超剂量提醒</div>
            </div>
            <div class="margin-top10">
              {{ checkTipsItem.sbchao }}
            </div>
          </div>
        </div>
        <div class="row-me flex-end1 margin-top30">
          <div class="btn-red width110 btn-height40" @click="clickDelete">审方作废</div>
          <div class="btn-green width110 btn-height40 margin-left10" @click="clickPassCheckForce"
               v-if="this.$method.isEmpty(checkTipsItem.kucun)">
            强制通过
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 设备选择 -->
    <el-dialog :title="'开始'+(detailItem.status.value===12?'煎药':detailItem.status.value===13?'包装':'')"
               v-model="visibleDevice" width="600px" top="20vh" :destroy-on-close="true" v-if="detailItem">
      <div class="padding20">
        <div class="row-me row-center">
          <div>选择{{ detailItem.status.value === 12 ? '煎药' : detailItem.status.value === 13 ? '包装' : '' }}机：</div>
          <div class="flex1">
            <el-select
                :placeholder="'选择'+(detailItem.status.value===12?'煎药':detailItem.status.value===13?'包装':'')+'机'"
                style="width: 100%;" filterable clearable v-model="chooseDevice">
              <el-option v-for="item in deviceArray" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me center-all margin-top100" v-if="detailItem.status.value===12">
          <div class="btn-blue width150 btn-height40" @click="clickPackage(0)">无煎药机煎药</div>
          <div class="btn-blue width150 btn-height40 margin-left50" @click="clickPackage(1)">分配煎药机煎药</div>
        </div>
        <div class="row-me center-all margin-top100" v-if="detailItem.status.value===13">
          <div class="btn-blue width150 btn-height40" @click="clickPackage(0)">无包装机包装</div>
          <div class="btn-blue width150 btn-height40 margin-left50" @click="clickPackage(1)">分配包装机包装</div>
        </div>
      </div>
    </el-dialog>

    <!-- 上传照片的弹窗 -->
    <el-dialog title="上传照片" v-model="visiblePhoto" width="600px" top="10vh" :destroy-on-close="true">
      <div class="row-me flex-wrap">
        <div class="item-photo" v-for="(item,index) in imageArray" :key="index">
          <el-image :src="item" :preview-src-list="imageArray" fit="cover" class="img-icon"
                    hide-on-click-modal>
            <template #error>
              <img src="../../assets/img/no_img_small.png" slot="error" class="width100Per height100Per objFitCover">
            </template>
          </el-image>
          <img src="../../assets/img/delete1.png" class="img-delete" @click="imageArray.splice(index,1)">
        </div>
        <el-upload class="avatar-uploader" action="" :show-file-list="false" multiple
                   :before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png" :auto-upload="true"
                   :http-request="uploadFile" :limit="9-imageArray.length" :on-exceed="uploadExceed"
                   v-if="imageArray.length<9">
          <div class="column-me center-all height100Per">
            <img class="img35" src="../../assets/img/add1.png"/>
          </div>
        </el-upload>
      </div>
      <div class="row-me flex-end1 margin-top30">
        <div class="btn-blue width120 btn-height40" @click="clickSaveImage">保存</div>
      </div>
    </el-dialog>

    <!-- 发货信息 -->
    <el-dialog title="发货信息" v-model="visibleSendInfo" width="60%" top="10vh" :destroy-on-close="true">
      <div class="row-me padding-left30 padding-right20">
        <div class="flex1">
          <div class="font-bold margin-left20">变更后发货信息</div>
          <div class="row-me margin-top20">
            <div class="left-title">配送方式：</div>
            <div class="flex1">{{ sendInfoItem.new.sfDeliveryCompany }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">寄件类型：</div>
            <div class="flex1">{{ sendInfoItem.new.sfSendType }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">运费方式：</div>
            <div class="flex1">{{ sendInfoItem.new.sfDeliveryType }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">月结卡号：</div>
            <div class="flex1">{{ sendInfoItem.new.sfMonthCard }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">是否保价：</div>
            <div class="flex1" v-if="sendInfoItem.new.sfIsInsure">保价</div>
            <div class="flex1" v-if="sendInfoItem.new.sfIsInsure===false">不保价</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">寄件方式：</div>
            <div class="flex1">{{ sendInfoItem.new.sfSendMethod }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">收件人信息：</div>
            <div class="flex1">{{ sendInfoItem.new.sfName }}&emsp;{{ sendInfoItem.new.sfMobile }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">收货地址：</div>
            <div class="flex1">
              {{ sendInfoItem.new.sfProvince }}
              {{ sendInfoItem.new.sfCity }}
              {{ sendInfoItem.new.sfRegion }}
              {{ sendInfoItem.new.sfAddress }}
            </div>
          </div>
        </div>
        <div class="flex1 margin-left50">
          <div class="font-bold margin-left20">原始发货信息</div>
          <div class="row-me margin-top20">
            <div class="left-title">配送方式：</div>
            <div class="flex1">{{ sendInfoItem.old.sfDeliveryCompany }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">寄件类型：</div>
            <div class="flex1">{{ sendInfoItem.old.sfSendType }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">运费方式：</div>
            <div class="flex1">{{ sendInfoItem.old.sfDeliveryType }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">运费金额：</div>
            <div class="flex1">{{ sendInfoItem.old.sfFreightFee }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">是否保价：</div>
            <div class="flex1" v-if="sendInfoItem.old.sfIsInsure">保价</div>
            <div class="flex1" v-if="sendInfoItem.old.sfIsInsure===false">不保价</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">寄件方式：</div>
            <div class="flex1">{{ sendInfoItem.old.sfSendMethod }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">收件人信息：</div>
            <div class="flex1">{{ sendInfoItem.old.sfName }}&emsp;{{ sendInfoItem.old.sfMobile }}</div>
          </div>
          <div class="row-me margin-top20">
            <div class="left-title">收货地址：</div>
            <div class="flex1">
              {{ sendInfoItem.old.sfProvince }}
              {{ sendInfoItem.old.sfCity }}
              {{ sendInfoItem.old.sfRegion }}
              {{ sendInfoItem.old.sfAddress }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog title="发货" v-model="visibleSend" width="60%" top="5vh" :destroy-on-close="true">
      <send-dialog :orderArray="[detailItem]" source="normal" @sendSuccess="sendSuccess"></send-dialog>
    </el-dialog>
  </div>
</template>

<script>
import deleteFang from './deleteFang.vue'
import passFang from './passFang.vue'
import cityData from '../../assets/js/citys.js'
import printPrescription from './printPrescription.vue'
import printTransferCode from './printTransferCode.vue'
import printLabel from './printLabel.vue'
import sendDialog from "./sendDialog.vue";

export default {
  components: {
    sendDialog,
    deleteFang,
    passFang,
    printPrescription,
    printTransferCode,
    printLabel,
  },
  props: {
    id: {
      type: Number,
      default: -1,
    }
  },
  data() {
    return {
      drugs: [],//药品明细
      constitutes: [],//组成明细
      records: [],//工艺记录
      activities: [],
      visibleDelete: false,
      deleteSource: '',//作废页面标志
      visibleProcess: false,
      selectWay: '', //服用方式
      amount: '',
      visibleDelivery: false,
      selectWaySend: '', //配送方式
      person: '', //收货人
      phone: '', //联系电话
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      selectProvince: '',
      selectCity: '',
      selectArea: '',
      address: '',
      visiblePassForce: false,
      deleteTitle: '', //作废弹窗标题
      deleteLeftTitle: '', //作废内容标题
      detailItem: null,
      drugArray: [], //药品下拉
      showCodeDrawer: false,
      showLabelDrawer: false,
      visibleRemark: false,
      remark: '',
      visibleCheckTips: false,//预审提示框
      checkTipsItem: {},//预审提示内容
      forceInfo: '',//强制通过展示信息
      visibleDevice: false,//选择设备机
      chooseDevice: '',//选择的设备
      imageArray: [],//附件图片集合
      visiblePhoto: false,
      selectStatus: '',//当前的状态
      canOperate: false,
      visibleSendInfo: false,//发货信息
      sendInfoItem: {},//发货信息
      visibleSend: false,//发货弹窗
    }
  },
  // 侦听器
  watch: {
    id(newVal, oldVal) {
      this.getDetail()
    },
  },
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.provinceArray = cityData
  },
  // html加载完成后执行。
  mounted() {
    if (this.id !== '' && this.id !== null) {
      this.getDetail()
    }
  },
  // 事件方法执行
  methods: {
    //替换药品
    drugChange(e, drug) {
      let pharmacyId = this.drugArray.find(item => {
        return item.id === e
      }).pharmacyId
      drug.pharmacyId = Number(pharmacyId)
    },
    //显示编辑
    clickShowEdit(item) {
      item.freightFee1 = item.freightFee
      item.showEditPrice = true
    },
    //修改价格
    clickPriceOk(item) {
      this.$postFormRequest('/admin/order/updateFreightFee', {
        id: item.id,
        price: Number(item.freightFee),
        type: 2,//type=1联单，2订单
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          item.showEditPrice = false
          this.getDetail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消修改价格
    clickPriceCancel(item) {
      item.freightFee = item.freightFee1
      item.showEditPrice = false
    },
    //上传图片验证
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png'];
      const isImage = types.includes(file.type);
      if (!isImage) {
        this.$message.error('上传图片只支持JPG、JPEG、PNG格式!')
        return false
      }
      const isSize = file.size / 1024 / 1024 //文件大小
      if (isSize > 5) {
        this.$message.error(`上传图片大小不能超过5MB!`);
        return false;
      }
      return true
    },
    //上传
    uploadFile(param) {
      let file = param.file;
      let formData = new FormData();
      formData.append("file", file);
      this.$uploadFileRequest('/file/upload', formData).then((res) => {
        if (res) {
          this.imageArray.push(res.data)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    uploadExceed(files, uploadFiles) {
      if (files.length + this.imageArray.length > 9) {
        this.$confirm("最多上传9张图片，还能最多选择" + (9 - this.imageArray.length) + "张", "温馨提示", {
          confirmButtonText: "知道了",
          showCancelButton: false,
          type: "warning",
        }).then(() => {
        }).catch(() => {
        });
      }
    },
    //上传照片
    clickUploadImage(status) {
      this.selectStatus = status
      for (let record of this.records) {
        if (record.name === status) {
          this.imageArray = record.images ? record.images.split(',') : []
        }
      }
      this.visiblePhoto = true
    },
    //保存图片
    clickSaveImage() {
      if (this.imageArray.length === 0) {
        this.$message.error('请先选择照片')
        return
      }
      this.$postFormRequest('/admin/order/addImage', {
        id: this.id,
        status: this.selectStatus,
        url: this.imageArray.join(','),
      }).then((res) => {
        if (res) {
          this.$message.success('上传成功')
          this.visiblePhoto = false
          this.getDetail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //省市改变
    cityChange1(e) {
      this.selectCity = ''
      this.selectArea = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (var i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange2(e) {
      this.selectArea = ''
      this.areaArray = []
      if (e && e !== '') {
        for (var i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //修改加工信息
    clickEditProcess() {
      this.selectWay = this.detailItem.takeMethod
      this.amount = this.detailItem.packageNums
      this.visibleProcess = true
    },
    //保存加工信息
    clickSaveProcess() {
      if (this.selectWay === '' || this.selectWay === null) {
        this.$message.error('请选择服用方法')
        return
      }
      if (this.amount === '' || this.amount === null) {
        this.$message.error('请输入包装量')
        return
      }
      this.$postRequest('/admin/order/update', {
        id: this.detailItem.id,
        takeMethod: this.selectWay,
        packageNums: this.amount,
      }).then((res) => {
        if (res) {
          this.getDetail()
          this.$message.success(res.message)
          this.visibleProcess = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickCancelProcess() {
      this.visibleProcess = false
    },
    //修改配送信息
    clickEditSend() {
      this.selectWaySend = this.detailItem.sfDeliveryType ? this.detailItem.sfDeliveryType : this.detailItem.deliveryType
      this.person = this.detailItem.sfName ? this.detailItem.sfName : this.detailItem.receiveName
      this.phone = this.detailItem.sfMobile ? this.detailItem.sfMobile : this.detailItem.receiveMobile
      this.selectProvince = this.detailItem.sfProvince ? this.detailItem.sfProvince : this.detailItem.receiveProvince
      this.selectCity = this.detailItem.sfCity ? this.detailItem.sfCity : this.detailItem.receiveCity
      this.selectArea = this.detailItem.sfRegion ? this.detailItem.sfRegion : this.detailItem.receiveRegion
      this.address = this.detailItem.sfAddress ? this.detailItem.sfAddress : this.detailItem.receiveAddress
      this.visibleDelivery = true
      let tempArray = this.provinceArray.filter((item) => {
        return item.n === this.selectProvince
      })
      this.cityArray = tempArray[0].c
      let tempArray1 = this.cityArray.filter((item) => {
        return item.n === this.selectCity
      })
      this.areaArray = tempArray1[0].c
    },
    //保存配送信息
    clickSaveSend() {
      if (this.selectWaySend === '' || this.selectWaySend === null) {
        this.$message.error('请选择配送方式')
        return
      }
      if (this.person === '' || this.person === null) {
        this.$message.error('请填写收货人')
        return
      }
      if (this.phone === '' || this.phone === null) {
        this.$message.error('请填写联系电话')
        return
      }
      if (this.selectProvince === '' || this.selectProvince === null) {
        this.$message.error('请选择省')
        return
      }
      if (this.selectCity === '' || this.selectCity === null) {
        this.$message.error('请选择市')
        return
      }
      if (this.selectArea === '' || this.selectArea === null) {
        this.$message.error('请选择区')
        return
      }
      if (this.address === '' || this.address === null) {
        this.$message.error('请输入详细地址')
        return
      }
      this.$postRequest('/admin/order/update', {
        id: this.detailItem.id,
        deliveryType: this.selectWaySend,
        receiveName: this.person,
        receiveMobile: this.phone,
        receiveProvince: this.selectProvince,
        receiveCity: this.selectCity,
        receiveRegion: this.selectArea,
        receiveAddress: this.address,
      }).then((res) => {
        if (res) {
          this.getDetail()
          this.$message.success(res.message)
          this.visibleDelivery = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickCancelSend: function () {
      this.visibleDelivery = false
    },
    //添加备注
    clickAddRemark() {
      //状态:0接方作废,1待接方,2待审方,3待配药,4配药中,5制药中,6待发货,7已完成,8调剂作废,9调剂,10复核,11泡药,
      // 12煎药,13包装,14审方作废
      //shenStatus ：0审方已作废，1已审方，2待入库，3已入库
      let remark = ''
      if (this.detailItem.status.value === 0 || this.detailItem.status.value === 1) {
        remark = this.detailItem.jieRemark
      } else if ((this.detailItem.status.value === 2 || this.detailItem.status.value === 14)
          && (this.$method.isEmpty(this.detailItem.shenStatus) || this.detailItem.shenStatus === 0 || this.detailItem.shenStatus === 1)) {
        remark = this.detailItem.shenRemark//待审方、审方作废、已审方的备注
      } else if (this.detailItem.status.value === 2 && (this.detailItem.shenStatus === 2 || this.detailItem.shenStatus === 3)) {
        remark = this.detailItem.zhiRemark//入库列表的备注
      } else if (this.detailItem.status.value === 8) {
        remark = this.detailItem.zhiRemark
      } else if (this.detailItem.status.value === 9) {
        remark = this.detailItem.tiaoRemark
      } else if (this.detailItem.status.value === 10) {
        remark = this.detailItem.fuRemark
      } else if (this.detailItem.status.value === 11) {
        remark = this.detailItem.paoRemark
      } else if (this.detailItem.status.value === 12) {
        remark = this.detailItem.jianRemark
      } else if (this.detailItem.status.value === 13) {
        remark = this.detailItem.baoRemark
      } else if (this.detailItem.status.value === 6) {
        remark = this.detailItem.faRemark
      }
      this.remark = remark
      this.visibleRemark = true
    },
    //保存备注
    clickSaveRemark() {
      if (this.$method.isEmpty(this.remark)) {
        this.$message.error('请输入备注')
        return
      }
      //状态:0接方作废,1待接方,2待审方,3待配药,4配药中,5制药中,6待发货,7已完成,8调剂作废,9调剂,10复核,11泡药,
      // 12煎药,13包装,14审方作废
      //shenStatus ：0审方已作废，1已审方，2待入库，3已入库
      let type = ''
      if (this.detailItem.status.value === 0 || this.detailItem.status.value === 1) {
        type = 1
      } else if ((this.detailItem.status.value === 2 || this.detailItem.status.value === 14)
          && (this.$method.isEmpty(this.detailItem.shenStatus) || this.detailItem.shenStatus === 0 || this.detailItem.shenStatus === 1)) {
        type = 2//待审方、审方作废、已审方的备注
      } else if (this.detailItem.status.value === 2 && (this.detailItem.shenStatus === 2 || this.detailItem.shenStatus === 3)) {
        type = 3//入库列表的备注
      } else if (this.detailItem.status.value === 8) {
        type = 3
      } else if (this.detailItem.status.value === 9) {
        type = 4
      } else if (this.detailItem.status.value === 10) {
        type = 5
      } else if (this.detailItem.status.value === 11) {
        type = 6
      } else if (this.detailItem.status.value === 12) {
        type = 7
      } else if (this.detailItem.status.value === 13) {
        type = 8
      } else if (this.detailItem.status.value === 6) {
        type = 9
      }
      this.$postRequest('/admin/order/jieAddRemark', {
        ids: [this.id],
        remark: this.remark,
        type: type,//1接方 2审方 3执行入库 4调剂添加备注, 5复核添加备注, 6泡药，7煎药，8包装，9发货
      }).then((res) => {
        if (res) {
          this.visibleRemark = false
          this.remark = ''
          this.$message.success('添加成功')
          this.getDetail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //接方通过
    clickPass() {
      this.$confirm("您确定要通过吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/receive', {
          ids: [this.detailItem.id],
          pass: true,
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {

      });
    },
    //接方作废
    clickDelete() {
      if (this.detailItem.status.value === 1) {
        this.deleteTitle = '接方作废'
        this.deleteLeftTitle = ''
        this.deleteSource = '接方'
      } else if (this.detailItem.status.value === 2) {
        this.deleteTitle = '审方作废'
        this.deleteLeftTitle = ''
        this.deleteSource = '审方'
      } else if (this.detailItem.status.value === 9) {
        this.deleteTitle = '调剂作废'
        this.deleteLeftTitle = ''
        this.deleteSource = '调剂'
      } else if (this.detailItem.status.value === 10) {
        this.deleteTitle = '复核驳回'
        this.deleteLeftTitle = '驳回原因'
        this.deleteSource = '复核'
      }
      this.visibleDelete = true
      this.bus.$off('deleteFangSuccess')
      this.bus.$on('deleteFangSuccess', res => {
        this.visibleDelete = false
        if (res === 'refresh') {
          this.visibleCheckTips = false
          this.getDetail()
        }
      })
    },
    //审方通过
    clickPassCheck() {
      //判断替换药是否填写
      for (let item of this.drugs) {
        if (this.$method.isEmpty(item.drugId)) {
          this.$confirm("处方内有需要替换的药品，请替换后再进行操作", "温馨提示", {
            confirmButtonText: "知道了",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
          }).catch(() => {
          });
          return
        }
      }
      this.$confirm("您确定要通过吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/order/check', {
          ids: [this.detailItem.id],
          pass: true,
          drugs: this.drugs,
        }).then((res) => {
          if (res) {
            if (res.code === 6000) {
              this.checkTipsItem = res.data
              this.visibleCheckTips = true
            } else {
              this.$message.success(res.message)
              this.getDetail()
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //强制通过
    clickPassCheckForce() {
      this.forceInfo = (this.checkTipsItem.sbchao || '') + (this.checkTipsItem.sbji || '') + '需要开方医师签字确认';
      this.visiblePassForce = true
      this.bus.$off('passFangSuccess')
      this.bus.$on('passFangSuccess', res => {
        this.visiblePassForce = false
        if (res === 'refresh') {
          this.visibleCheckTips = false
          this.getDetail()
        }
      })
    },
    //调剂完成
    clickTiaoPass() {
      this.$confirm("您确定要调剂完成吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/tiaojiFinish', {
          ids: [this.detailItem.id],
          type: 1,//0驳回，1完成
          remark: '',
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //复核通过
    clickFuHePass() {
      this.$confirm("您确定要复核通过吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/fuheFinish', {
          ids: [this.detailItem.id],
          type: 1,//0驳回，1完成
          remark: '',
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //开始泡药
    clickStartPao() {
      this.$confirm("您确定开始泡药吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/paoyaoFinish', {
          ids: [this.detailItem.id],
          type: 0,//0开始，1完成
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //泡药完成
    clickEndPao() {
      this.$confirm("您确定泡药完成吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/paoyaoFinish', {
          ids: [this.detailItem.id],
          type: 1,//0开始，1完成
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //开始煎药
    clickStartJian() {
      //判断系统参数配置
      this.$getRequest('/admin/systemConfig/getIsJianYao', {}).then((res) => {
        if (res) {
          if (res.data) {//有
            this.visibleDevice = true
          } else {//无
            this.clickPackage(0)
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //煎药完成
    clickEndJian() {
      this.$confirm("您确定煎药完成吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/jianyaoFinish', {
          ids: [this.detailItem.id],
          type: 1,//0开始，1完成
          equipmentId: '',//设备id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //开始包装
    clickStartBao() {
      //判断系统参数配置
      this.$getRequest('/admin/systemConfig/getIsBaozhuang', {}).then((res) => {
        if (res) {
          if (res.data) {//有
            this.visibleDevice = true
          } else {//无
            this.clickPackage(0)
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //包装完成
    clickEndBao() {
      this.$confirm("您确定包装完成吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/baozhuangFinish', {
          ids: [this.detailItem.id],
          type: 1,//0泡药，1完成
          equipmentId: '',//设备id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //选择完设备开始煎药或包装
    clickPackage(index) {
      let title = this.detailItem.status.value === 12 ? '煎药' : this.detailItem.status.value === 13 ? '包装' : ''
      let url = this.detailItem.status.value === 12 ? '/admin/order/jianyaoFinish' : this.detailItem.status.value === 13 ? '/admin/order/baozhuangFinish' : ''
      if (index === 1 && this.$method.isEmpty(this.chooseDevice)) {
        this.$message.error("请选择" + title + "机")
        return
      }
      this.visibleDevice = false
      this.$postFormRequest(url, {
        ids: [this.detailItem.id],
        type: 0,//0开始，1完成
        equipmentId: index === 1 ? this.chooseDevice : '',//设备id
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
        }
        this.getDetail()
        this.chooseDevice = ''
      }).catch((error) => {
        console.log(error)
      })
    },
    //打印处方
    clickPrintTransfer() {
      if (this.$method.isEmpty(this.detailItem) || this.$method.isEmpty(this.detailItem.id)) {
        this.$message.error('操作太快，请稍后')
        return
      }
      this.$refs.printPage.getDetail()
    },
    //打印调配码
    clickPrintBarCode() {
      if (this.$method.isEmpty(this.detailItem) || this.$method.isEmpty(this.detailItem.id)) {
        this.$message.error('操作太快，请稍后')
        return
      }
      this.showCodeDrawer = true
    },
    //打印标签
    clickPrintLabel() {
      if (this.$method.isEmpty(this.detailItem) || this.$method.isEmpty(this.detailItem.id)) {
        this.$message.error('操作太快，请稍后')
        return
      }
      this.showLabelDrawer = true
    },
    //导出药品
    clickExportMedicine() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderId: this.id,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/drugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //发货
    clickSend() {
      this.visibleSend = true
    },
    //查看发货信息
    clickSendInfo() {
      this.$postFormRequest('/admin/order/fahuoInfo', {
        id: this.id
      }).then((res) => {
        if (res) {
          this.sendInfoItem = res.data
          this.visibleSendInfo = true
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取详情
    getDetail() {
      this.activities = []
      this.drugs = []
      this.constitutes = []
      this.$getRequest('/admin/order/get/' + this.id, {}).then((res) => {
        if (res) {
          this.detailItem = res.data
          this.activities = res.data.logs
          this.drugs = res.data.drugs
          this.constitutes = res.data.constitutes
          this.records = res.data.records
          if (this.$refs.drugTable) {
            this.$refs.drugTable.doLayout()
          }
          if (this.detailItem.status.value === 2) {
            this.getDrugArray()
          }
          this.getDeviceArray()
          //获取当前是否操作权限
          // 状态:0已作废,1待接方,2待审方,3待配药,4配药中,5制药中,6待发货,7已完成,8调剂作废,9调剂,10复核,11泡药,
          // 12煎药,13包装,14审方作废
          let nowPath = ''
          if (this.detailItem.status.value === 1) {
            nowPath = '/receiveManage'
          } else if (this.detailItem.status.value === 2) {
            nowPath = '/checkManage'
          } else if (this.detailItem.status.value === 9) {
            nowPath = '/adjustment'
          } else if (this.detailItem.status.value === 10) {
            nowPath = '/review'
          } else if (this.detailItem.status.value === 11) {
            nowPath = '/bubbleMedicine'
          } else if (this.detailItem.status.value === 12) {
            nowPath = '/boilMedicine'
          } else if (this.detailItem.status.value === 13) {
            nowPath = '/packageManage'
          } else if (this.detailItem.status.value === 6) {
            nowPath = '/sendManage'
          }
          this.$getMenuOperateAuth(nowPath).then(res => {
            this.canOperate = res.data
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取药品下拉
    getDrugArray() {
      let param = {
        type: this.detailItem.type
      }
      if (this.detailItem.isCustomTransdermalDelivery !== null) {
        param.isCustomTransdermalDelivery = this.detailItem.isCustomTransdermalDelivery
      }
      this.$getRequest('/admin/drug/list', param).then((res) => {
        if (res) {
          this.drugArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取煎药机、包装机下拉
    getDeviceArray() {
      this.$getRequest('/admin/systemConfig/equipmentAll', {
        type: this.detailItem.status.value === 12 ? 1 : this.detailItem.status.value === 13 ? 2 : '',//1煎药机，2包装机
        enableStatus: 1,//1已启用，2已停用
        useStatus: 2,//使用状态1使用中，2空闲
      }).then((res) => {
        if (res) {
          this.deviceArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //发货成功
    sendSuccess() {
      this.visibleSend = false
      this.getDetail()
    },
  },
}
</script>

<style lang="scss" scoped>
.fangDetail {
  margin: -20px;

  .main-content {
    height: 87vh;
    overflow: auto;
    position: relative;

    .table-border-l-t {
      border-left: 1px solid #E5E9ED;
      border-top: 1px solid #E5E9ED;

      .title {
        width: 100px;
        padding: 8px 10px;
        background: #FAFAFA;
        font-size: 16px;
        color: #7B8CA0;
        border-right: 1px solid #E5E9ED;
        border-bottom: 1px solid #E5E9ED;
      }

      .content {
        flex: 1;
        padding: 8px 10px;
        font-size: 16px;
        color: #252630;
        border-right: 1px solid #E5E9ED;
        border-bottom: 1px solid #E5E9ED;
      }
    }

    .top-div {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 60px;
      overflow: auto;

      .left-div {
        flex: 1;
      }

      .right-div {
        width: 45vw;
        margin-left: 40px;
      }

      .time-div {
        padding: 30px 40px;

        .title1 {
          font-size: 20px;
          color: #252630;
        }

        .title2 {
          font-size: 18px;
          color: #7B8CA0;
          margin-top: 8px;
        }

        .info-div {
          width: 496px;
          background: #F5F6F8;
          border-radius: 4px;
          padding: 8px;
        }

        .step-text {
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #A9B6C4;
          border-radius: 50%;
          font-size: 18px;
          color: #FFFFFF;
        }

        .step-text1 {
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #215AA0;
          border-radius: 50%;
          font-size: 18px;
          color: #FFFFFF;
        }
      }

      .img-photo {
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }
    }

    .bottom-div {
      height: 60px;
      background: #FFFFFF;
      box-shadow: 0 0 20px #CCCCCC;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding-right: 20px;
    }
  }

  .item-photo {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    position: relative;

    .img-icon {
      width: 100px;
      height: 100px;
    }

    .img-delete {
      width: 30px;
      height: 30px;
      object-fit: scale-down;
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }

  :deep(.avatar-uploader .el-upload) {
    border: 1px solid #cccccc;
    border-radius: 10px;
    width: 100px;
    height: 100px;
  }

  .left-title {
    width: 110px;
    text-align: right;
    margin-right: 10px;
  }

  .img-table {
    height: 20px;
    object-fit: scale-down;
    margin-left: 10px;
  }
}
</style>
